import React, { useEffect, useState } from 'react'
import { SlSocialReddit } from "react-icons/sl";
import { FaFacebookF, FaYoutube, FaInstagramSquare } from "react-icons/fa"
import InformationPrimary from '../../../components/admin/activitescontent/InformationPrimary';
import InfoText from '../../../components/admin/activitescontent/InfoText';
import { LoadAllManagerAllPage, LoadAllManagerHomePage, LoadAllManagerPage } from '../../../actions/ActivitesPages/ManagerPageAction';
import FormHome from '../../../components/admin/activitescontent/legendes/FormHome';
import FormAbout from '../../../components/admin/activitescontent/legendes/FormAbout';
import FormSubscribe from '../../../components/admin/activitescontent/legendes/FormContact';

const ActiviteContentList = () => {

    const [ManagerPage, setManagerPage] = useState([]);
    // useEffect(() => {
    //     LoadAllManagerHomePage(setManagerPage)
    // }, []);


    return (
        <div className="translatable w-full">
            <div className="translatable py-1 my-2 mx-1 bg-cyan-700 text-white px-2 py-2 rounded-lg flex justify-center ">
                <h2 className="translatable  text-white flex space-x-3 items-center text-xl"><SlSocialReddit className="translatable text-white w-8 h-8" />Listes des activité des pages</h2>
            </div>
            <div className="translatable py-3 px-7 flex flex-wrap justify-between ">
                <h2 className="translatable text-3xl flex flex-row">
                    Activités des pages ( <span className="translatable  flex flex-row space-x-3 "> <FaFacebookF className="translatable h-6 w-6  text-blue-600 " />
                        <FaYoutube className="translatable h-6 w-6  text-red-600 " />
                        <FaInstagramSquare className="translatable h-6 w-6  text-violet-600 " />
                    </span>
                    )
                </h2>
                <div>
                    {
                        /**
                         * 
                         * <button type="button" className="translatable btn btn-primary bg-dark" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                        Ajouter
                    </button>
                         */
                    }

                    {/* Ajouter Modal */}
                    <div className="translatable modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div className="translatable modal-dialog">
                            <div className="translatable modal-content">
                                <div className="translatable modal-header">
                                    <h5 className="translatable modal-title" id="staticBackdropLabel">Modal </h5>
                                    <button type="button" className="translatable btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="translatable modal-body">
                                    ...
                                </div>
                                <div className="translatable modal-footer">
                                    <button type="button" className="translatable btn btn-secondary" data-bs-dismiss="modal">fermer</button>
                                    <button type="sumbit" className="translatable btn btn-primary">enregsitrer</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="translatable row">

                {/* pages tabs */}

                <div className="translatable col-md-12 mb-4">
                    <div className="translatable card shadow">
                        <div className="translatable card-body">
                            <ul className="translatable nav nav-tabs  nav-pills nav-justified" role="tablist">
                                <li className="translatable nav-item" role="presentation">
                                    <a className="translatable nav-link active" data-bs-toggle="tab" href="#home" aria-selected="true" role="tab">Accueil</a>
                                </li>
                                <li className="translatable nav-item" role="presentation">
                                    <a className="translatable nav-link" data-bs-toggle="tab" href="#about" aria-selected="false" role="tab" tabindex="-1">A propos de nous </a>
                                </li>
                                {
                                    /*
                                    
                                    <li className="translatable nav-item" role="presentation">
                                    <a className="translatable nav-link" data-bs-toggle="tab" href="#contact" aria-selected="false" role="tab" tabindex="-1">contact</a>
                                </li>*/
                                }
                                <li className="translatable nav-item" role="presentation">
                                    <a className="translatable nav-link" data-bs-toggle="tab" href="#subscribe" aria-selected="false" role="tab" tabindex="-1">Contact</a>
                                </li>
                            </ul>
                            <div id="myTabContent" className="translatable tab-content">
                                <div className="translatable tab-pane fade active show" id="home" role="tabpanel">
                                    <p><FormHome/></p>
                                </div>
                                <div className="translatable tab-pane fade" id="about" role="tabpanel">
                                    <FormAbout/>
                                </div>
                                {
                                    /*
                                    <div className="translatable tab-pane fade" id="contact">
                                    <p>Contact</p>
                                </div>*/
                                }
                                <div className="translatable tab-pane fade" id="subscribe">
                                    <FormSubscribe/>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ActiviteContentList;